import { useEffect } from 'react';
import { useNavigate, useParams, Link } from 'react-router-dom';
import { useDispatch, useSelector } from "react-redux";
import apiRequest from '../../../../../utils/apiRequest';
import { COURIER_ORDERS, COURIER_DELIVER_TO_CUSTOMER, IMAGE_ADDRESS } from '../../../../../apis';
import { handleChangeDataCourierOrderDetails } from '../../../../../redux/actions/pages/courier/orderDetails';
import { LazyLoadImage } from "react-lazy-load-image-component";
import LocalShippingIcon from '@mui/icons-material/LocalShipping';



const CourierOrderDetails = () => {

	const dispatch = useDispatch();
	const navigate = useNavigate();

	const { uniqueCode } = useParams();

	const { isBackdropLoading } = useSelector(state => state.allLoaders);
	const { courierToken } = useSelector(state => state.courierLogin);
	const { content } = useSelector(state => state.courierOrderDetails);
	const { isMobile } = useSelector(state => state.general);

	

	useEffect(() => {
		dispatch(handleChangeDataCourierOrderDetails('content', {}));
        apiOrderDetails();
    }, []);



	const apiOrderDetails = () => {
		if(! isBackdropLoading) {
			apiRequest({
			    dispatch,
			    endpoint: COURIER_ORDERS + '/' + uniqueCode,
			    method: 'get',
			    token: courierToken, 
			    onSuccess: (res) => {
			      	dispatch(handleChangeDataCourierOrderDetails('content', res.content));
			    },
		  	});
		}
	};


	const handleDeliverToCustomer = () => {
		if(! isBackdropLoading) {
			apiRequest({
			    dispatch,
			    endpoint: COURIER_DELIVER_TO_CUSTOMER + '/' + uniqueCode,
			    method: 'get',
			    token: courierToken,
			    successMessage: "محموله به مشتری تحویل شد", 
			    onSuccess: (res) => {
			      	navigate(-1);
			    },
		  	});
		}
	};

	const toPersianDigits = (num) => {
  		return num.toString().replace(/\d/g, d => '۰۱۲۳۴۵۶۷۸۹'[d]);
	};

    return (
    	
    	<div className="lg:bg-neutral-000 lg:rounded-medium overflow-hidden lg:border-complete-200">
			<div className="border-complete-b-200 mb-2 lg:mb-0">
				<div className="bg-neutral-000 flex items-center border-complete-b-200 px-3 py-4 lg:px-6 mb-2 lg:mb-0">
					<div className="cursor-pointer" onClick={() => navigate(-1)}>
						<div className="flex">
							<svg style={{width: '24px', height: '24px', fill: 'var(--color-icon-high-emphasis)'}}>
								<use xlinkHref="#arrowRight" />
							</svg>
						</div>
					</div>
					<div className="grow text-h5 text-neutral-900 mr-2">جزئیات سفارش
					</div>
					{ ! isMobile && content.status && content.status === "shipped" &&
						<a onClick={handleDeliverToCustomer} className="flex items-center gap-1 text-button-2 text-primary-500 cursor-pointer">
							<div className="flex">
								{/*<svg style={{width: '18px', height: '18px', fill: 'var(--color-icon-secondary)'}}>
									<use xlinkHref="#invoice" />
								</svg>*/}
								<LocalShippingIcon />
							</div>تحویل به مشتری
						</a>
					}
				</div>
				<div className="bg-neutral-000 px-5 py-4 lg:px-6">
					<div className="flex flex-col lg:flex-row items-stretch lg:items-center gap-3 gap-y-2 pb-4 border-complete-b">
						<div className="flex items-center justify-between lg:justify-start gap-1">
							<div className="text-body-1 text-neutral-500 ml-1">کد محموله
							</div>
							<div className="text-body1-strong text-neutral-800">{toPersianDigits(uniqueCode)}
							</div>
						</div>
						<div className="flex hidden lg:flex">
							<svg style={{width: '16px', height: '16px', fill: 'var(--color-icon-disable)'}}>
								<use xlinkHref="#dotOutline" />
							</svg>
						</div>
						<div className="flex items-center justify-between lg:justify-start gap-1">
							<div className="text-body-1 text-neutral-500 ml-1">تاریخ ثبت سفارش
							</div>
							<div className="text-body1-strong text-neutral-800">{toPersianDigits(content.registerDate ?? '')}
							</div>
						</div>
						<div className="flex items-center justify-between lg:justify-start gap-1">
							<div className="text-body-1 text-neutral-500 ml-1">زمان تحویل
							</div>
							<div className="text-body1-strong text-neutral-800">{toPersianDigits(content.deliveryDate ?? '')} بازه {toPersianDigits(content.deliveryTime ?? '')}
							</div>
						</div>
					</div>
					<div className="flex flex-col lg:flex-row items-stretch lg:items-center gap-3 gap-y-2 pt-4 pb-2">
						<div className="flex items-center justify-between lg:justify-start gap-1">
							<div className="text-body-1 text-neutral-500 ml-1">مبدا
							</div>
							<div className="text-body1-strong text-neutral-800">{content.sellerTitle ?? ''}
							</div>
						</div>
						<div className="flex hidden lg:flex">
							<svg style={{width: '16px', height: '16px', fill: 'var(--color-icon-disable)'}}>
								<use xlinkHref="#dotOutline" />
							</svg>
						</div>
						<div className="flex items-center justify-between lg:justify-start gap-1">
							<div className="text-body-1 text-neutral-500 ml-1">شماره موبایل
							</div>
							<div className="text-body1-strong text-neutral-800">{toPersianDigits(content.sellerMobile ?? '')}
							</div>
						</div>
					</div>
					<div className="flex flex-col lg:flex-row items-stretch lg:items-center justify-between gap-2">
						<div className="flex items-center justify-between lg:justify-start gap-1 grow flex-col lg:flex-row items-start pb-4 border-complete-b">
							<div className="text-body-1 text-neutral-500 ml-1 self-start whitespace-nowrap">آدرس
							</div>
							<div className="text-body1-strong text-neutral-800 text-body1-strong self-start">{content.sellerAddress ?? ''}
							</div>
						</div>
					</div>


					<div className="flex flex-col lg:flex-row items-stretch lg:items-center gap-3 gap-y-2 pt-4 pb-2">
						<div className="flex items-center justify-between lg:justify-start gap-1">
							<div className="text-body-1 text-neutral-500 ml-1">مقصد
							</div>
							<div className="text-body1-strong text-neutral-800">{content.userName ?? ''}
							</div>
						</div>
						<div className="flex hidden lg:flex">
							<svg style={{width: '16px', height: '16px', fill: 'var(--color-icon-disable)'}}>
								<use xlinkHref="#dotOutline" />
							</svg>
						</div>
						<div className="flex items-center justify-between lg:justify-start gap-1">
							<div className="text-body-1 text-neutral-500 ml-1">شماره موبایل
							</div>
							<div className="text-body1-strong text-neutral-800">{toPersianDigits(content.userMobile ?? '')}
							</div>
						</div>
					</div>
					<div className="flex flex-col lg:flex-row items-stretch lg:items-center justify-between gap-2">
						<div className="flex items-center justify-between lg:justify-start gap-1 grow flex-col lg:flex-row items-start">
							<div className="text-body-1 text-neutral-500 ml-1 self-start whitespace-nowrap">آدرس
							</div>
							<div className="text-body1-strong text-neutral-800 text-body1-strong self-start">{content.userAddress ?? ''}
							</div>
						</div>
					</div>


				</div>
			</div>


			

			<div className="px-3 mt-5 lg:mt-0">
				{
					content.products?.map((product, key) => (
						<div className={`py-4 ${key + 1 < content.products.length ? 'border-complete-b-200' : ''}`}>
							<div className="bg-neutral-000 py-4 lg:pr-4 mx-4 lg:mx-0" data-testid="cart-item">
								<div className="styles_CartItem__grid__rZXPE">
									<div className="flex flex-col items-center">
										<Link className="relative" >
											<div style={{width: '114px', height: '114px', lineHeight: 0}}>
												<picture>
													<LazyLoadImage className="w-full inline-block" src={IMAGE_ADDRESS + product.image} width={114} height={114} alt={product.title} title style={{objectFit: 'contain'}} />
												</picture>
											</div>
											<div className="bg-neutral-000 absolute bottom-0 left-0 rounded-small text-center text-neutral-900 text-caption-strong styles_CartItem__imageQuantity__bzt41">۱
											</div>
										</Link>
										<div className="mr-2" />
									</div>
									<div className="overflow-x-hidden">
										<div className>
											<h3 className="text-neutral-800 text-body1-strong mb-2">{product.title}
											</h3>
										</div>
									</div>
								</div>
								

							</div>
							<div className="gap-2 flex flex-wrap" />
						</div>
					))
				}
			</div>


			{ content.status && content.status === "shipped" &&
			<div className="fixed w-full left-0 bottom-14 flex justify-end lg:hidden pb-4 px-5">
				<button onClick={handleDeliverToCustomer} className="font-iran-yekan flex items-center justify-between text-button-1 styles-FabButton styles-FabButton-primary px-4 py-3 px-4 shadow-fab-button whitespace-nowrap">
					<div className="flex items-center justify-content-center">
						<div className="ml-2">تحویل به مشتری</div>
						<div className="flex styles-FabButton-icon">
							{/*<svg style={{width: '24px', height: '24px', fill: 'var(--color-icon-white)'}}>
								<use xlinkHref="#newAddress"></use>
							</svg>*/}
							<LocalShippingIcon sx={{fontSize: "24px"}}/>
						</div>
					</div>
				</button>
			</div>
			}






		</div>

    );
}

export default CourierOrderDetails;